export enum Structure
{
    Board,
    Queue
}

export type SegmentEnd = "S" | "E"  //start, end

export type Direction = "B" | "F" //'back, forward'